import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import Pagination from "react-js-pagination";
import {apiService} from '../../common/apiCallService';
import Loading from '../Loading.js';
import {baseUrl} from '../../common/config.js';
import Menu from '../Menu.js'
import { Redirect } from 'react-router';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import Paper from 'material-ui/Paper';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import validator from 'validator';
import NewModulesNlessons from './NewModulesNlessons.js';
import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card';
import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';
import { createVirtualPageLoad, closeVirtualPage } from '../../common/commonService'

class NewContent extends Component {

  constructor(props) {
    super(props)
    this.state = {
      loginRedirect: false,
      id:'',
      courses:[],
      modules:[],
      lessons:[],
      counter:{
         chartCounter:1,
         videoCounter: 1,
      },
      upNdown:{
        textUp:false,
        textDown:true,
        videoUp:true,
        videoDown:true,
        chartUp:true,
        chartDown:false,
      },
      contentForm:{
        textContent:'',
        textOrder:1,
        videoOrder:2,
        chartOrder:3,
        selectedModuleId:'',
        selectedLessonId:'',
        courseId:'',
        video:[{title:'',url:''}],
        chart:[{title:'',url:'',hoverText:''}],

      },
      msg:'',
      checkContent:false,
      open:false,
      openModuleNLessonDialog:false,
      loading: true,
      content:[{type:'text',order:'1'},{type:'video',order:'2'},{type:'chart',order:'3'}]
    }
      this.getCourse()
  }

  componentDidMount() {
    createVirtualPageLoad("/newContent")
  }

  componentWillUnmount() {
    closeVirtualPage()
  }

  setToDefault = () => {
    let contentFrm = this.state.contentForm
    contentFrm.textContent=''
    contentFrm.textOrder=1
    contentFrm.videoOrder=2
    contentFrm.chartOrder=3
    contentFrm.video=[{title:'',url:''}]
    contentFrm.chart=[{title:'',url:'',hoverText:''}]
    this.setState({contentFrm})
    let counterObj = this.state.counter
    counterObj.chartCounter = 1
    counterObj.videoCounter = 1
    this.setState({counterObj})
    let upDownObj = this.state.upNdown
    upDownObj.textUp=false
    upDownObj.textDown=true
    upDownObj.videoUp=true
    upDownObj.videoDown=true
    upDownObj.chartUp=true
    upDownObj.chartDown=false
    this.setState({upDownObj})
    this.setState({
      msg:'',
      checkContent:false,
      open:false,
      newModulesNlessonsFlag:false,
      content:[{type:'text',order:'1'},{type:'video',order:'2'},{type:'chart',order:'3'}]
    })
    this.forceUpdate()
  }

  validate = () => {
    this.setState({courseId_error: ''})
    this.setState({selectedModuleId_error: ''})
    this.setState({selectedLessoId_error: ''})
    this.setState({content_error: ''})


    if(!this.state.contentForm.courseId || this.state.contentForm.courseId == 'Select') return this.setState({courseId_error: 'Course is required'})
    if(!this.state.contentForm.selectedModuleId || this.state.contentForm.selectedModuleId == 'Select') return this.setState({selectedModuleId_error: 'Module is required'})
    if(!this.state.contentForm.selectedLessonId || this.state.contentForm.selectedLessonId == 'Select') return this.setState({selectedLessoId_error: 'Lesson is required'})

    let videoList = this.state.contentForm.video.filter((content) =>{
      delete content.videoUrl_error
      delete content.videoTitle_error
      if(Object.keys(content).length >0){
        if(content.title == '' && content.url == ''){}
        else if(content.title == '' && !content.url){}
        else return content
      }
    })
    this.state.contentForm.video = videoList
    this.state.counter.videoCounter=videoList.length
    for (let j = 0; j < this.state.contentForm.video.length; j++) {
     if(!this.state.contentForm.video[j].title) return this.state.contentForm.video[j].videoTitle_error = 'Video title is required'
     if(!this.state.contentForm.video[j].url) return this.state.contentForm.video[j].videoUrl_error = 'Video url is required'
     if(!validator.isURL(this.state.contentForm.video[j].url)) return this.state.contentForm.video[j].videoUrl_error = 'Enter valid url'
    }

    let chartList = this.state.contentForm.chart.filter((content) =>{
      delete content.chartUrl_error
      delete content.chartTitle_error
      if(Object.keys(content).length >0){
        if(content.title == '' && content.url == ''){}
        else if(content.title == '' && !content.url){}
        else return content
      }
    })
    this.state.contentForm.chart = chartList
    this.state.counter.chartCounter=chartList.length
    for (let j = 0; j < this.state.contentForm.chart.length; j++) {
      if(!this.state.contentForm.chart[j].title) return this.state.contentForm.chart[j].chartTitle_error = 'Chart title is required'
      if(!this.state.contentForm.chart[j].url) return this.state.contentForm.chart[j].chartUrl_error = 'Chart url is required'
      if(!validator.isURL(this.state.contentForm.chart[j].url)) return this.state.contentForm.chart[j].chartUrl_error = 'Enter valid url'
      if(!this.state.contentForm.chart[j].hoverText) return this.state.contentForm.chart[j].hoverText_error = 'Hover text is required'
    }

    if(this.state.checkContent)
     this.updateContent()
    else
     this.saveContent()

  }

  onDelete = () =>{
    let id=[]
    this.setState({loading: false})
    if(this.state.contentForm.textId)  id.push(this.state.contentForm.textId)
    if(this.state.contentForm.videoId) id.push(this.state.contentForm.videoId)
    if(this.state.contentForm.chartId) id.push(this.state.contentForm.chartId)
    this.forceUpdate()
      apiService(baseUrl + '/clinic/deleteContent', {
          "contentForm":id,
      }, (data) => {
        this.setState({
          msg: data.msg,
          open: true,
          loading:false
        })
      }, (data) => {
          this.setState({loading: false})
          if(data.status == 403) {
            localStorage.setItem("pathName", this.props.location.pathname)
            this.setState({loginRedirect: true})
          }
      })
  }

  handleClose = () => {
     this.setState({
       loginRedirect: false,
       open: false,
       modules:[],
       lessons:[]
     })
     this.setToDefault()
     this.state.contentForm.selectedLessonId=''
     this.state.contentForm.selectedModuleId=''
     this.state.contentForm.courseId='Select'
     this.forceUpdate()
   };

  saveContent = () => {
    this.setState({loading: false})
    let rows = document.getElementById("table").rows,
        index = 1
    this.state.contentForm.textContent=this.refs.textContent.value
    for(let i=1; i<rows.length; i++){
      if(rows[i].getAttribute('id') == 'text' && this.state.contentForm[rows[i].getAttribute('id')+'Content'] != undefined){
        this.state.contentForm[rows[i].getAttribute('id')+'Order'] = index
        index++
      }
      else if(rows[i].getAttribute('id') != 'text' &&  this.state.contentForm[rows[i].getAttribute('id')].length != 0){
        this.state.contentForm[rows[i].getAttribute('id')+'Order'] = index
        index++
      }
    }
    this.forceUpdate()
      apiService(baseUrl + '/clinic/saveContent', {
          "contentForm":this.state.contentForm,
      }, (data) => {
        this.setState({
          msg: data.msg,
          open: true,
          content: [],
          loading:false
        })
      }, (data) => {
          this.setState({loading: false})
          if(data.status == 403) {
            localStorage.setItem("pathName", this.props.location.pathname)
            this.setState({loginRedirect: true})
          }
      })
  }

  updateContent = () =>{
    this.setState({loading: false})
    let rows = document.getElementById("table").rows,
        index = 1
    this.state.contentForm.textContent=this.refs.textContent.value
    for(let i=1; i<rows.length; i++){
      if(this.state.contentForm[rows[i].getAttribute('id')] != '' || this.state.contentForm[rows[i].getAttribute('id')].length != 0){
        index=i
        this.state.contentForm[rows[i].getAttribute('id')+'Order']=index
      }
    }

    apiService(baseUrl + '/clinic/updateContent', {
        "contentForm":this.state.contentForm,
    }, (data) => {
      this.setState({
        msg: data.msg,
        open: true,
        loading:false
      })
    }, (data) => {
        this.setState({loading: false})
        if(data.status == 403) {
          localStorage.setItem("pathName", this.props.location.pathname)
          this.setState({loginRedirect: true})
        }
    })
  }

  getCourse = () => {
    this.setState({loading: true})
    apiService(baseUrl + '/clinic/getCourse', {
        "type": 'Course',
    }, (data) => {
      this.setState({
        courses: data,
        loading: false
      })
    }, (data) => {
      this.setState({loading: false})
      if(data.status == 403) {
        localStorage.setItem("pathName", this.props.location.pathname)
        this.setState({loginRedirect: true})
      }
    })
  }

  getModules = () => {
    this.setState({loading: true})
    apiService(baseUrl + '/clinic/getModules', {
        "_id": this.state.contentForm.courseId
    }, (data) => {
      this.setState({modules: data})
      this.setState({loading: false})
    }, (data) => {
      this.setState({loading: false})
      if(data.status == 403) {
        localStorage.setItem("pathName", this.props.location.pathname)
        this.setState({loginRedirect: true})
      }
    })
  }

  handleChange = (event, index, value) => this.setState({value});

  onModuleChange = (event, index, value) => {

     this.setState({
       loginRedirect: false,
       value: '',
       lessons:[]
     })
     this.setToDefault()
     this.state.contentForm.selectedModuleId = value
     this.state.contentForm.selectedLessonId='Select'
     this.forceUpdate()
     this.getLessons()
  }

  onLessonChange = (event, index, value) => {
     this.state.contentForm.selectedLessonId = value
     this.checkContent()
  }

  getLessons = () => {
     this.setState({loading: true})
     apiService(baseUrl + '/clinic/getLessons', {
         "_id": this.state.contentForm.selectedModuleId,
     }, (data) => {
       this.setState({lessons: data.lessons})
       this.setState({loading: false})
     }, (data) => {
       this.setState({loading: false})
       if(data.status == 403) {
         localStorage.setItem("pathName", this.props.location.pathname)
         this.setState({loginRedirect: true})
       }
     })
  }

  checkContent = () => {
    this.setState({loading: true})
    apiService(baseUrl + '/clinic/getLessonContent', {
        "moduleID": this.state.contentForm.selectedModuleId,
        "lessonID":this.state.contentForm.selectedLessonId
    }, (data) => {
      this.setState({content: []})
      if(data.length >0){
         this.state.content=data
          this.state.checkContent=true
          let checkList = data.filter((content) => content.type == 'text')
          if(checkList.length == 0) this.state.content.push({ type: "text", textContent: ''});

          checkList = data.filter((content) => content.type == 'video')
          if(checkList.length == 0) this.state.content.push({ type: "video", videoContent: [{}]});

          checkList = data.filter((content) => content.type == 'chart')
          if(checkList.length == 0) this.state.content.push({ type: "chart", chartContent: [{}]});

          for(let i=0;i<data.length;i++){
            if(data[i].type !='text'){
              this.state.counter[data[i].type+'Counter']=data[i][data[i].type+'Content'].length
              this.state.contentForm[data[i].type]=data[i][data[i].type+'Content']
            }
            else{
              this.state.contentForm[data[i].type+'Content']=data[i][data[i].type+'Content'].replace(/<br\s*\/?>/ig, "\r");
            }
            this.state.contentForm[data[i].type+'Id'] = data[i]._id

            if(i==0){
              this.state.upNdown[data[i].type+'Up']=false
              this.state.upNdown[data[i].type+'Down']=true
            }
            else if(i==data.length-1){
              this.state.upNdown[data[i].type+'Up']=true
              this.state.upNdown[data[i].type+'Down']=false
            }
            else{
              this.state.upNdown[data[i].type+'Up']=true
              this.state.upNdown[data[i].type+'Down']=true
            }
        }
        this.forceUpdate()
      }
      else{
        this.setToDefault()
        this.forceUpdate()
      }
      this.setState({loading: false})
      this.forceUpdate()
  }, (data) => {
      this.setState({loading: false})
      if(data.status == 403) {
        localStorage.setItem("pathName", this.props.location.pathname)
        this.setState({loginRedirect: true})
      }
    })
  }

  onTitleChange = (event,value,contentType,i) => {
     this.state.contentForm[contentType][i].title = value
     this.forceUpdate()
  }

  onUrlChange = (event,value,contentType,i) => {
     this.state.contentForm[contentType][i].url = value
     this.forceUpdate()
  }

  onhoverTextChange = (event,value,i) => {
     this.state.contentForm.chart[i].hoverText = value
     this.forceUpdate()
  }

  onContentChange = (event,value) => {
     this.state.contentForm.textContent=value
     this.forceUpdate()
  }

  addVideoContent = () => {
    let videoContent = [];
    for(let i=0; i< this.state.counter.videoCounter;i++){
      videoContent.push(
       <div>
        <Card expanded={true} style={{backgroundColor:'#2D2C34'}}>
          <CardText style={{paddingTop:'0',}}>
            <span style={{padding:'0', float:'right'}}>
              <i className="fa fa-minus-circle"  aria-hidden="true" style={{fontSize:'30px',color:'red'}} onClick={(event) => this.removeContent(event,'video',i)}></i>
            </span>
             <TextField  floatingLabelText="Title"   hintText="Title of video" style={{width:'100%'}} value={this.state.contentForm.video[i].title}
              onChange = {(event,newValue) => this.onTitleChange(event, newValue,'video', i)}
              errorText={this.state.contentForm.video[i].videoTitle_error}/>
             <br/>
             <TextField  floatingLabelText="URL"   hintText="URL of video" style={{width:'100%'}} value={this.state.contentForm.video[i].url}
              onChange = {(event, newValue) => this.onUrlChange(event, newValue,'video', i)}
              errorText={this.state.contentForm.video[i].videoUrl_error}/>
          </CardText>
        </Card>
        <br/>
        </div>
      )
    }
     return videoContent;
  }

  addChartContent = () => {
    let chartContent = [];
    for(let i=0; i< this.state.counter.chartCounter;i++){
      chartContent.push(
        <div>
          <Card expanded={true} style={{backgroundColor:'#2D2C34'}}>
            <CardText style={{paddingTop:'0',}}>
              <span style={{padding:'0', float:'right'}}>
                <i  className="fa fa-minus-circle"  aria-hidden="true" style={{fontSize:'30px',color:'red'}} onClick={(event) => this.removeContent(event,'chart',i)}></i>
              </span>
              <TextField  floatingLabelText="Title"   hintText="Title of content" style={{width:'100%'}} value={this.state.contentForm.chart[i].title}
               onChange = {(event,newValue) => this.onTitleChange(event, newValue,'chart', i)}
               errorText={this.state.contentForm.chart[i].chartTitle_error}/>
              <br/>
              <TextField  floatingLabelText="URL" hintText="URL of content" style={{width:'100%'}} value={this.state.contentForm.chart[i].url}
               onChange = {(event,newValue) => this.onUrlChange(event, newValue,'chart', i)}
               errorText={this.state.contentForm.chart[i].chartUrl_error}/>
              <br/>
              <TextField  floatingLabelText="Hover Text" hintText="Hover Text" style={{width:'100%'}} value={this.state.contentForm.chart[i].hoverText}
               onChange = {(event,newValue) => this.onhoverTextChange(event, newValue,i)}
               errorText={this.state.contentForm.chart[i].hoverText_error}/>
            </CardText>
          </Card>
          <br/>
        </div>
      )
    }
     return chartContent;
  }

  addContent = (event,contentType) =>{
    this.state.counter[contentType+'Counter'] = this.state.counter[contentType+'Counter'] + 1
     if(contentType == 'chart') this.state.contentForm[contentType].push( {title:'',url:'',hoverText:''})
     else this.state.contentForm[contentType].push( {title:'',url:'',videoTitle_error:'',videoUrl_error:''})
     this.forceUpdate()
  }

  removeContent = (event,contentType,index) =>{
    this.state.counter[contentType+'Counter'] = this.state.counter[contentType+'Counter'] - 1
    this.state.contentForm[contentType].splice(index, 1)
    this.forceUpdate()
  }

  upNdown = (event,id,direction) =>{
     let rows = document.getElementById("table").rows;
      let   index=document.getElementById(id).rowIndex,
         parent = rows[index].parentNode;
      if(direction === "up"){
        if(index > 1){
          parent.insertBefore(rows[index],rows[index - 1])
          index--
        }
      }
      if(direction === "down"){
        if(index < rows.length -1){
          parent.insertBefore(rows[index + 1],rows[index])
          index++
        }
      }
      for(let i=1; i<rows.length; i++){
        if(i==1){
          this.state.upNdown[rows[i].getAttribute('id')+'Up']=false
          this.state.upNdown[rows[i].getAttribute('id')+'Down']=true
        }
        else if(i==rows.length - 1){
          this.state.upNdown[rows[i].getAttribute('id')+'Up']=true
          this.state.upNdown[rows[i].getAttribute('id')+'Down']=false
        }
        else{
          this.state.upNdown[rows[i].getAttribute('id')+'Up']=true
          this.state.upNdown[rows[i].getAttribute('id')+'Down']=true
        }
        this.forceUpdate()
      }
  }

	newModulesNlessonsDialog = () =>{
    this.setState({openModuleNLessonDialog:false})
    this.getCourse()
  }

  closeModuleNLessonDialog = () => {
    this.setState({openModuleNLessonDialog: false})
  }

  onCourseChange = (event,index,value) => {
    this.state.contentForm.courseId = value
    this.state.contentForm.selectedModuleId='Select'
    this.forceUpdate()
    this.getModules()
  }

  render() {
    this.props.setHeaderTitle("New Content");
    const actions = [
        <FlatButton
          label="CANCEL"
          primary={true}
          onClick={this.closeModuleNLessonDialog}
        />,
        <FlatButton
          label="SUBMIT"
          primary={true}
          onClick={() => this.refs.newModulesNlessons.validate()}
        />,
        ];
    return (
      <div>
        {this.state.loading
          ? <Loading/>
          : null}
        {this.state.loginRedirect && (<Redirect to={'/'}/> )}
        <div className="container">
          <br/>
        </div>
        <center>
          <Paper zDepth={5} className="resp-paper" style={{backgroundColor: '#2D2C34',paddingTop: '10px',width:'70%'}}>
            <div>
              <Dialog
                actions={<FlatButton label="Ok" data-e2e="OK" primary={true} keyboardFocused={true} onClick={this.handleClose}/>}
                modal={false}
                open={this.state.open}
                onRequestClose={this.handleClose}
              >
              {this.state.msg}
              </Dialog>
            </div>
            <div style={{float:'right', paddingRight:'8px'}}>
             <RaisedButton label="Add Module/Lessons" secondary={true} onClick={(event) =>this.setState({openModuleNLessonDialog:true})}/>
             <Dialog
               actions={actions}
               modal={true}
               title='New Module or Lesson'
               open={this.state.openModuleNLessonDialog}
               onRequestClose={this.closeModuleNLessonDialog}
             >
              <NewModulesNlessons  ref = "newModulesNlessons" newModulesNlessonsDialog ={this.newModulesNlessonsDialog} pathname={this.props.location.pathname}/>
             </Dialog>
            </div>
            <table className="table" style={{marginBottom:'0px'}} id="table">
              <tbody>
                <tr>
                 <td  style={{border:'none'}}>
                   <Card expanded={true} style={{backgroundColor:'#1f1e23'}}>
                     <CardText>
                     <SelectField
                       floatingLabelText="Select Course"
                       value={this.state.contentForm.courseId}
                       style={{textAlign: 'left'}}
                       onChange = {(event, index, value) =>  this.onCourseChange(event, index, value)}
                       errorText={this.state.courseId_error}
                       >
                       <MenuItem value='Select' primaryText="Select" disabled/>
                       {this.state.courses.map((obj, index) => {
                         return <MenuItem  key={obj._id} value={obj._id} primaryText={obj.contentName}/>
                       })}
                     </SelectField>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                       <SelectField
                          floatingLabelText="Modules"
                          value={this.state.contentForm.selectedModuleId}
                          onChange={this.onModuleChange}
                          errorText={this.state.selectedModuleId_error}
                        >
                          <MenuItem value='Select' primaryText="Select" disabled/>
                          {this.state.modules.map((obj, index) => {
                            return <MenuItem  value={obj._id} primaryText={obj.contentName}/>
                          })}
                      </SelectField>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      <SelectField
                        floatingLabelText="Lesson"
                        value={this.state.contentForm.selectedLessonId}
                        onChange={this.onLessonChange}
                        errorText={this.state.selectedLessoId_error}
                      >
                       <MenuItem value='Select' primaryText="Select" disabled/>
                         {this.state.lessons.map((obj, index) => {
                           return <MenuItem  value={obj._id} primaryText={obj.contentName}/>
                         })}
                     </SelectField>
                    </CardText>
                   </Card>
                 </td>
                </tr>
                {this.state.content.map((obj,index) =>{
                  return(<tr id={obj.type}>
                  <td style={{borderTop:'none'}}>
                    <Card expanded={true} style={{backgroundColor:'#1f1e23'}}>
                      <div style={{border:'none',padding:'16px 16px 0px', paddingBottom:'5px'}}>
                        <span style={{textTransform:'capitalize'}}>
                          {obj.type == 'text' ? <b>Content:</b>:<b>{obj.type}s:</b>}
                        </span>
                          {this.state.upNdown[obj.type+'Up']
                            ?<div style={{float:'right'}}><i className="fa fa-arrow-up" aria-hidden="true" style={{color:'green',fontSize:'20px'}} onClick={(event) => this.upNdown(event,obj.type,'up')}></i></div>
                            :null}
                          {this.state.upNdown[obj.type+'Down']
                            ?<div style={{float:'right'}}><i className="fa fa-arrow-down" aria-hidden="true" style={{color:'red',fontSize:'20px'}} onClick={(event) => this.upNdown(event,obj.type,'down')}></i></div>
                            :null}
                         </div>
                      <CardText style={{paddingTop:'0',}}>
                        {obj.type == 'text'
                          ?<textarea placeholder="Enter Content" style={{width:'100%',backgroundColor:'#2D2C34',border:'none',color:'white',padding:'16px'}} value={this.state.contentForm.textContent} ref='textContent'
                            onChange = {(event,newValue) => this.onContentChange(event,newValue)} errorText = {this.state.content_error}  />
                          :null}
                        {obj.type == 'video'
                          ?<span>{this.addVideoContent()}
                            <br/>
                            <RaisedButton label="Add more" secondary={true} onClick={(event) => this.addContent(event,'video')}/>&nbsp;&nbsp;</span>
                          :null}
                        {obj.type == 'chart'
                          ?<span>{this.addChartContent()}
                           <br/>
                           <RaisedButton label="Add more" secondary={true} onClick={(event) => this.addContent(event,'chart')}/>&nbsp;&nbsp;</span>
                          :null}
                      </CardText>
                    </Card>
                  </td>
                  </tr>)
                 })
                }
            </tbody>
          </table>
        <div>
           {this.state.checkContent
             ?<div className='row'>
                <center><div className='col-xs-6'><RaisedButton label="Update" primary={true} onClick={(event) => this.validate(event)}/></div></center>
                <center><div className='col-xs-6'><RaisedButton label="Delete" primary={true} onClick={(event) => this.onDelete(event)}/></div></center>
              </div>
             :<center><div ><RaisedButton label="SUBMIT" primary={true} onClick={(event) => this.validate(event)}/></div></center>
           }
        </div>
          </Paper>
        </center>
      </div>
    )
  }

}


const mapDispatchToProps = dispatch => {
  return {
    setHeaderTitle : ( newTitle ) => dispatch(actions.setHeaderTitle( newTitle ))
  }
};

export default connect(null, mapDispatchToProps)(NewContent);



/** WEBPACK FOOTER **
 ** ./src/components/Course/NewContent.js
 **/